export const slugify = (value) =>
  String(value || "menu")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "") || "menu";

export const createMenuId = (prefix = "item") =>
  `${prefix}-${Date.now()}-${Math.random().toString(16).slice(2)}`;

export const withMenuIds = (categories = []) =>
  categories.map((category, categoryIndex) => ({
    id: category.id || `cat-${slugify(category.name)}-${categoryIndex}`,
    name: category.name || "Untitled section",
    blurb: category.blurb || "",
    items: (category.items || []).map((item, itemIndex) => ({
      id:
        item.id ||
        `item-${slugify(category.name)}-${slugify(item.name)}-${itemIndex}`,
      name: item.name || "Untitled item",
      description: item.description || "",
      tag: item.tag || "",
      price: item.price || "",
      available: item.available !== false,
    })),
  }));

export const cleanMenuForSave = (categories = []) =>
  categories
    .map((category) => ({
      ...category,
      name: category.name.trim(),
      blurb: category.blurb.trim(),
      items: (category.items || [])
        .map((item) => ({
          ...item,
          name: item.name.trim(),
          description: item.description.trim(),
          tag: item.tag.trim(),
          price: item.price.trim(),
          available: item.available !== false,
        }))
        .filter((item) => item.name),
    }))
    .filter((category) => category.name);